import { useState } from "react";
import { useParams } from "react-router-dom";
import { User, Clock, MapPin, Truck, CreditCard } from "lucide-react";

export default function OrderDetailsTab() {
  const { orderId } = useParams();
  const [open, setOpen] = useState("shipping");

  // dummy order
  const order = {
    customer: {
      firstName: "Dolite",
      lastName: "Bullock",
      email: "abbott@withinpixels.com",
      phone: "+1-202-555-0175",
      company: "Saois",
      shippingAddress:
        "377 E South Omaha Bridge Rd, Council Bluffs, IA 51501, USA",
      invoiceAddress:
        "377 E South Omaha Bridge Rd, Council Bluffs, IA 51501, USA",
    },
    status: [
      { id: 1, name: "On pre-order (not paid)", date: "2016/04/03 10:06:18" },
      { id: 2, name: "Awaiting check payment", date: "2015/03/17 18:28:37" },
    ],
    payment: {
      transactionId: "2a894b9e",
      method: "Credit Card",
      amount: "$73.31",
      date: "2016/02/23 15:50:23",
    },
    shipping: [
      {
        tracking: "TNT",
        carrier: "TNT",
        weight: "10.44",
        fee: "$7.00",
        date: "2015/04/10 07:03:52",
      },
    ],
  };

  return (
    <div className="space-y-10">
      <section className="bg-border rounded-lg border border-border p-0 lg:p-5 shadow-sm">
        <h2 className="text-lg font-semibold mb-3 flex items-center gap-2 text-text">
          <User className="w-5 h-5 text-text" />
          Customer
        </h2>
        <div className="overflow-x-auto scrollbar-thin">
          <table className="min-w-full text-sm text-left ">
            <thead className="border border-dry bg-dry text-text">
              <tr>
                <th className="p-3 border border-border">Name</th>
                <th className="p-3 border border-border">Email</th>
                <th className="p-3 border border-border">Phone</th>
                <th className="p-3 border border-border">Company</th>
              </tr>
            </thead>
            <tbody>
              <tr className="hover:bg-textGray text-textGray">
                <td className="p-3 border border-dry text-textGray">
                  <div className="flex gap-2 items-center ">
                    <img
                      src="https://images.pexels.com/photos/2955375/pexels-photo-2955375.jpeg"
                      alt="avatar"
                      className="w-8 h-8 rounded-full"
                    />
                    Doltie Bullock{" "}
                  </div>
                </td>
                <td className="p-3 border border-dry ">
                  abbott@withinpixels.com
                </td>
                <td className="p-3 border border-dry">+1-202-555-0175</td>
                <td className="p-3 border border-dry">Saois</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mt-5">
          <h2 className="text-lg font-semibold mb-3 flex items-center gap-2 text-text">
            <MapPin className="w-5 h-5 text-text" />
            Shipping Address
          </h2>

          <div className="p-4 rounded border border-dry">
            <p className="text-textGray text-sm leading-relaxed">
              377 E South Omaha Bridge Rd,
              <br />
              Council Bluffs, IA 51501, USA
            </p>
          </div>
        </div>
      </section>
      <section className="bg-border rounded-lg border border-border p-5 shadow-sm">
        <h2 className="text-lg font-semibold mb-3 flex items-center gap-2 text-text">
          <Clock className="w-5 h-5 text-text" />
          Order Status
        </h2>
        <div className="overflow-x-auto scrollbar-thin">
          <table className="min-w-max text-sm text-left border border-border text-text">
            <thead className="bg-dry">
              <tr>
                <th className="p-3 border border-dry">Status</th>
                <th className="p-3 border border-dry">Updated On</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border border-dry">
                  <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium">
                    On pre-order (not paid)
                  </span>
                </td>
                <td className="p-3 border border-dry">2016/04/03 10:06:18</td>
              </tr>
              <tr>
                <td className="p-3 border border-dry">
                  <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
                    Awaiting check payment
                  </span>
                </td>
                <td className="p-3 border border-dry">2015/03/17 18:28:37</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Payment */}
      <section className="bg-border rounded-lg border border-border p-5 shadow-sm">
        <h2 className="text-lg font-semibold mb-3 flex items-center gap-2 text-text">
          <CreditCard className="w-5 h-5 text-text" />
          Payment
        </h2>
        <div className="overflow-x-auto scrollbar-thin">
          <table className="min-w-max text-sm text-left border border-border text-text">
            <thead className="bg-dry">
              <tr>
                <th className="p-3 border border-dry">Transaction ID</th>
                <th className="p-3 border border-dry">Payment Method</th>
                <th className="p-3 border border-dry">Amount</th>
                <th className="p-3 border border-dry">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border border-dry">2a894b9e</td>
                <td className="p-3 border border-dry">Credit Card</td>
                <td className="p-3 border border-dry">$73.31</td>
                <td className="p-3 border border-dry">2016/02/23 15:50:23</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Shipping */}
      <section className="bg-border rounded-lg border border-border p-5 shadow-sm">
        <h2 className="text-lg font-semibold mb-3 flex items-center gap-2 text-text">
          <Truck className="w-5 h-5 text-text" />
          Shipping
        </h2>
        <div className="overflow-x-auto scrollbar-thin">
          <table className="min-w-max text-sm text-left border border-border text-text">
            <thead className="bg-dry">
              <tr>
                <th className="p-3 border border-dry">Tracking Code</th>
                <th className="p-3 border border-dry">Carrier</th>
                <th className="p-3 border border-dry">Weight</th>
                <th className="p-3 border border-dry">Fee</th>
                <th className="p-3 border border-dry">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border border-dry">TNT</td>
                <td className="p-3 border border-dry">TNT</td>
                <td className="p-3 border border-dry">10.44</td>
                <td className="p-3 border border-dry">$7.00</td>
                <td className="p-3 border border-dry">2015/04/10 07:03:52</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <hr className="py-20 border-0" />
    </div>
  );
}
